import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import HomeBody from './HomeBody';
import LogInBody from './LogInBody';
import StatsBody from './StatsBody';
import ShopBody from './ShopBody';
import AboutBody from './AboutBody';
import NewsBody from './NewsBody';
import LogOutBody from './LogOutBody';
import ProfileBody from './ProfileBody';
import { IState } from '../state/State';
import { connect } from 'react-redux';
import { ILogInType } from '../actions/LogInActions';

export interface IBodyProps {
  logInState: ILogInType,
}

const Body: React.FC<IBodyProps> = (props: IBodyProps) => {
    let isUserLoggedIn: boolean = props.logInState.accessToken != null;

    let profileBody;
    if (isUserLoggedIn) {
      profileBody = <ProfileBody />
    }
    else {
      profileBody = <LogInBody />
    }

    return (
      <div className="Body">
        <Switch>
          {/* <Route path="/home"><HomeBody /></Route> */}
          <Route path="/login"><LogInBody /></Route>
          <Route path="/logout"><LogOutBody /></Route>
          {/* <Route path="/about"><AboutBody /></Route> */}
          {/* <Route path="/news"><NewsBody /></Route> */}
          {/* <Route path="/shop"><ShopBody /></Route> */}
          <Route path="/stats"><StatsBody /></Route>
          <Route path="/profile">{profileBody}</Route>
          <Route path="/"><Redirect to="/stats" /></Route>
        </Switch>
      </div>
    );
  }

  const mapStateToProps = (state: IState) => ({logInState: state.logIn.result});
  
  export default connect(mapStateToProps)(Body);